import Vue from 'vue';
import batchIngredienceTransformer from '../../transformers/batchIngredience';
import store from '../../store';

const success = (resolve, response) => {
  batchIngredienceTransformer.fetchCollection(response.data).forEach((data) => {
    store.dispatch('addBatchIngredience', data);
  });
  resolve();
};

const failed = (errors, reject) => {
  reject(batchIngredienceTransformer.fetch(errors));
};

export default (batchId, batchIngrediences) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post(`/production/batch/${batchId}/batch_ingredience/bulk`, { items: batchIngredienceTransformer.sendCollection(batchIngrediences) })
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/batchIngredience/bulkStore.js